<template>
  <div>
    <ejs-dialog
        ref="daumPostcodePopupDialog"
        id="daumPostcodePopupDialog"
        header="주소찾기"
        :animationSettings="animationSettings"
        :allowDragging="true"
        :showCloseIcon="true"
        width="640"
        height="500"
        :close="dialogClose"
        :position="{ x: 'center' }"
        :enableResize="false"
        :isModal="true"
    >
      <div ref="postcodeContainer" style="width:100%;height:100%;"></div>
    </ejs-dialog>
  </div>
</template>

<script>
const POSTCODE_SCRIPT_SRC =
    "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";


function loadPostcodeScript() {
  return new Promise((resolve, reject) => {
    if (window.daum && window.daum.Postcode) {
      resolve();
      return;
    }
    const existing = document.querySelector(
        'script[data-daum-postcode="true"]'
    );
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = POSTCODE_SCRIPT_SRC;
    script.dataset.daumPostcode = "true";
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}


export default {
  name: "daumPostcodePopup",
  data() {
    return {
      animationSettings: { effect: "None" },
    };
  },
  methods: {
    async showPopup() {
      this.$refs.daumPostcodePopupDialog.show();
      try {
        await loadPostcodeScript();
      } catch (e) {
        console.error("Daum Postcode script load failed", e);
        return;
      }
      await this.$nextTick();
      const container = this.$refs.postcodeContainer;
      if (!container || !window.daum || !window.daum.Postcode) {return;}
      container.innerHTML = "";
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.onConfirmClicked(data);
        },
        width: "100%",
        height: "100%",
      }).embed(container);
    },
    dialogClose() {
      this.$emit("popupClosed", null);
    },
    onCloseClicked() {
      this.$refs.daumPostcodePopupDialog.hide();
    },
    onConfirmClicked(data) {
      this.$emit("popupConfirmed", data);
    },
  },
};
</script>
